var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M11.807 3.102c-1.802-.136-5.815-.136-7.615 0C2.244 3.25 2.014 4.558 2 8c.014 3.436.242 4.75 2.192 4.898 1.8.136 5.813.136 7.615 0C13.756 12.75 13.985 11.442 14 8c-.014-3.436-.242-4.75-2.193-4.898zM6 10V6l4 1.997L6 10z"
  })));
};
export default SvgYoutube;